// extracted by mini-css-extract-plugin
export var icon = "ExpandingSection-module--icon--fa321";
export var outer = "ExpandingSection-module--outer--15eca";